import React, { useState } from 'react'

import { navigate } from 'gatsby'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import * as CestaActions from '../../../../../common/context/actions/cestaActions'
import { ProductInfo } from '../../../../../common/context/actions/cestaActions'
import styles from './cta.module.scss'
import downArrowBlackSvg from './down_black_arrow.svg'
import Select, { components } from 'react-select'
import { DropDownOption } from '../../../../components/DropDown/DropDown'
import { isPromocionForProductos } from '../../../../../common/context/selectors/cestaSelectors'
import { DataSteps, Steps } from '../../../../../common/components/cesta/Steps'
import { selectPostCode } from '../../../../../common/context/selectors/userSelectors'
import { IAppState } from '../../../../../common/context/context'
import { intl, t } from '../../../../../common/i18n'
import WhiteBoxContainer from '../../../../components/WhiteBoxContainer'
import Button from '../../../../components/Button/Button'
import Garantia from './Garantia'
import { Promocion, PromocionBanner } from './promocion/Promocion'
import { CatalogoProductInfo } from '../CatalogoProductInfo'

interface Props {
  onSelectedNeumatico: (productInfo: ProductInfo, cantidad: number) => void
  catalogoProductInfo: CatalogoProductInfo
  options: DropDownOption[]
  montaje?: React.ReactNode
  showGarantia?: boolean
  bannerPromocion?: Promocion
  ecoTasaPrice?: React.ReactNode
}

const ComprarProductoCTA: React.FC<Props> = ({
  onSelectedNeumatico,
  catalogoProductInfo,
  options,
  montaje,
  showGarantia,
  bannerPromocion,
  ecoTasaPrice,
}) => {
  const { producto, productInfo } = catalogoProductInfo

  const defaultOption = producto.ecotasa
    ? options.find((option) => option.value === '2') || options[0]
    : options.find((option) => option.value === '1') || options[0]
  const activo = producto.disponibilidad
  const [cantidad, setCantidad] = useState<DropDownOption>(defaultOption)

  const onClickComprar = () => {
    if (activo) {
      onSelectedNeumatico(productInfo, Number(cantidad.value))
    }
  }

  let crossedPrice
  if (
    producto.promocion &&
    producto.promocion.importePromocion &&
    isPromocionForProductos(producto.promocion)
  ) {
    crossedPrice = (
      <div className={styles.priceSinPromo}>
        <del>
          {intl.formatNumber(catalogoProductInfo.importeSinPromo, {
            style: 'currency',
            currency: 'EUR',
          })}
        </del>
        &nbsp;
      </div>
    )
  }
  const onChangeQuantity = (event: DropDownOption | null) => {
    if (event) setCantidad(event)
  }

  const formatDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <div className={styles.dropdownIndicator}>
        <img src={downArrowBlackSvg} alt="Down arrow" />
      </div>
    </components.DropdownIndicator>
  )

  return (
    <section>
      <WhiteBoxContainer className={'yellow'}>
        <div className={`${styles.wrapper} ${styles.wrapper_col}`}>
          <div
            className={`${styles.price_header} ${styles.price_header_neumatico}`}>
            {crossedPrice}
            <span className={styles.price_text}>
              {producto.promocion && isPromocionForProductos(producto.promocion)
                ? intl.formatNumber(
                    catalogoProductInfo.importe -
                      producto.promocion.importePromocion,
                    {
                      style: 'currency',
                      currency: 'EUR',
                    }
                  )
                : intl.formatNumber(catalogoProductInfo.importe, {
                    style: 'currency',
                    currency: 'EUR',
                  })}
              {producto.ecotasa && (
                <span className={styles.perNeumatico}>
                  {t(
                    'catalogo.producto.ficha.section_cta.por_unidad_neumatico'
                  )}
                </span>
              )}
            </span>
          </div>
          {ecoTasaPrice &&
            React.cloneElement(ecoTasaPrice as React.ReactElement<any>, {
              cantidad: cantidad.value,
            })}
          <div className={styles.cta_wrapper}>
            <div className={styles.dropdown_container}>
              <Select
                id={'cantidad'}
                value={cantidad}
                options={options}
                components={{
                  DropdownIndicator: formatDropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                onChange={onChangeQuantity}
              />
            </div>
            <div className={styles.elegir_button}>
              <Button
                buttonClass={'rodi_full_width_rounded'}
                onClick={onClickComprar}
                disabled={!activo}>
                {t('landing_neumaticos.comprar')}
              </Button>
            </div>
          </div>
        </div>
      </WhiteBoxContainer>
      {bannerPromocion.texto_promociones && (
        <div className={styles.neumatico_card__promobanner}>
          <PromocionBanner promocion={bannerPromocion} />
        </div>
      )}
      {montaje}
      {showGarantia && <Garantia />}
    </section>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onSelectedNeumatico: (productInfo: ProductInfo, cantidad: number) => {
      dispatch(CestaActions.addProduct(productInfo, 'database', null, cantidad))
      dispatch(CestaActions.setStep(Steps.TU_SOLICITUD))
      navigate(DataSteps[Steps.TU_SOLICITUD].route)
    },
  }
}

const mapStateToProps = (state: IAppState) => {
  return {
    postCode: selectPostCode(state),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ComprarProductoCTA)
